export default __webpack_public_path__ + "static/media/resteo.90de15df.png";